import { Component, OnInit, ViewChild } from '@angular/core';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { ToastrService } from 'ngx-toastr';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { AccessControlPolicy } from 'src/app/models/usermanagement/accessControl';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AccesscontrolPolicyService } from 'src/app/services/accesscontrol-policy.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-access-control',
  templateUrl: './access-control.component.html',
  styleUrls: ['./access-control.component.scss']
})
export class AccessControlComponent implements OnInit {
  @ViewChild(MatTable) table!: MatTable<AccessControlPolicy> ;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: any;
  groupList!: any[];
  GroupId!: any;
  IsAccess: any;
  IsWrite: any;
  formMode!: boolean;
  breadcrumList: any;
  policyData!: MatTableDataSource<AccessControlPolicy>;
  policyDataArray!:AccessControlPolicy[];
  displayUserModal = false;
  policyForm!: FormGroup;
  userForm!: FormGroup; 
  policyRowId!: number;
  isCheckPrevious: boolean;
  policyColumns: string[] = ['policyId', 'minimumLength', 'isAlphanumeric', 'isSymbols', 'expiryPeriod', 'logOffTimeOut', 'failedAttempt', 'noOfPreviousPass', 'policyActions'];
 
  constructor(
    private roleService: UserManagementService,
    private toaster: ToastrService,
    private kpiMaster: KpimasterService,
    private fb: FormBuilder,
    private policyService: AccesscontrolPolicyService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.formMode = true;
  this.getGroupsData();

  this.GetBreadcrumList();
  this.userForm = this.fb.group({
    group: ['']
  });
  this.policyForm = this.fb.group({
    minimumLength: ['', [Validators.required,Validators.min(1)]],
    isAlphanumeric: [''],
    isSymbol: [''],
    expiryPeriod: ['',[Validators.required,Validators.min(1)]],
    logOffTimeOut: ['',[Validators.required,Validators.min(1)]],
    failedAttempt: ['',[Validators.required,Validators.min(1)]],
    isCheckPreviousPass: [''],
    noOfPreviousPass: ['']
  });
  }

  CheckStatus(){
    this.isCheckPrevious = this.policyForm.value.isCheckPreviousPass ? true : false;
    if(this.isCheckPrevious){
      this.policyForm.get("noOfPreviousPass").setValidators([Validators.required,Validators.min(1)]);
      this.policyForm.get("noOfPreviousPass").updateValueAndValidity();
    }else{
      this.policyForm.get('noOfPreviousPass').setValue('');
      this.policyForm.get('noOfPreviousPass').clearValidators();
      this.policyForm.get('noOfPreviousPass').updateValueAndValidity();
    }
  }

  addNewPolicyFormSubmit(){
    const noOfPasswords = this.policyForm.value.noOfPreviousPass;
    const data = {
      minimumLength: parseInt(this.policyForm.value.minimumLength, 10),
      isAlphanumeric: this.policyForm.value.isAlphanumeric ? true : false,
      isSymbols: this.policyForm.value.isSymbol ? true : false,
      expiryPeriod: parseInt(this.policyForm.value.expiryPeriod, 10),
      logOffTimeOut: parseInt(this.policyForm.value.logOffTimeOut, 10),
      failedAttempt: parseInt(this.policyForm.value.failedAttempt, 10),
      groupId: parseInt(this.userForm.value.group, 10),
      userId: parseInt(JSON.parse(localStorage.user).UserId, 10),
      isCheckPreviousPassword: this.policyForm.value.isCheckPreviousPass ? true : false,
      noOfPreviousPassword: this.isCheckPrevious ? parseInt(noOfPasswords,10) : 0
    };
    this.policyService.craetePolicy(data).subscribe(res => {
      
      this.toaster.success(res.message);
      this.displayUserModal = false;
      this.getpolicy();
    },
    (error) => {
      this.toaster.error(error.message);
    });
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.policyData.filter = filterValue.trim().toLowerCase();
  
    if (this.policyData.paginator) {
      this.policyData.paginator.firstPage();
    }
  }

  getpolicy(): void {
      this.spinner.show();
      this.policyService.getPolicyByGroup(parseInt(this.userForm.value.group, 10)).subscribe(
      (policy: any) => {
        this.policyData = new MatTableDataSource<any>(policy);
        this.policyDataArray = policy;
      this.spinner.hide();
        this.getPaginator();
      },
      (error) => {
      this.spinner.hide();
        this.toaster.error(error.error.message);
      }
    );
  }

  getPaginator(): void {
    setTimeout(() => {
      this.policyData.paginator = this.paginator;
      this.policyData.sort = this.sort;
    }, 1000);
  }

  openModal(): void {
    this.isCheckPrevious = false;
    this.formMode = true;
    this.policyForm.reset();
    this.displayUserModal = true;
  }

  editPolicyFormSubmit(){
    const noOfPasswords = this.policyForm.value.noOfPreviousPass;
    const data = {
      id: this.policyRowId,
      minimumLength: parseInt(this.policyForm.value.minimumLength, 10),
      isAlphanumeric: this.policyForm.value.isAlphanumeric ? true : false,
      isSymbols: this.policyForm.value.isSymbol ? true : false,
      expiryPeriod: parseInt(this.policyForm.value.expiryPeriod, 10),
      logOffTimeOut: parseInt(this.policyForm.value.logOffTimeOut, 10),
      failedAttempt: parseInt(this.policyForm.value.failedAttempt, 10),
      groupId: parseInt(this.userForm.value.group, 10),
      userId: parseInt(JSON.parse(localStorage.user).UserId, 10),
      isCheckPreviousPassword: this.policyForm.value.isCheckPreviousPass ? true : false,
      noOfPreviousPassword: this.isCheckPrevious ? parseInt(noOfPasswords,10) : 0
    };
    this.policyService.updatePolicy(data).subscribe(res => {      
      this.toaster.success(res.message);
      this.displayUserModal = false;
      this.getpolicy();
    },
    (error) => {
      this.toaster.error(error.message);
    });
  }

  getGroupsData(): void {
    const key = {
      Id: 0,
    };
    this.roleService.getGroupData(key).subscribe((data: any) => {
      this.groupList = data.masterList;
      this.GroupId = this.groupList[0].TypeId;
      this.userForm.get('group').setValue(this.GroupId);
      this.getpolicy();
    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  closeaddNewPlantItemModel(): void {
    this.displayUserModal = false;
  }
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.kpiMaster.GetMenuAccess(key).subscribe((data: any) => {
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;

    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  onGroupChange(event: any): void {
    this.getpolicy();
  }

  GetBreadcrumList(): any{
    const obj = {
      MenuId: localStorage.getItem('O3RightMenuId') === null ? 1 : localStorage.getItem('O3RightMenuId')
    };
    // tslint:disable-next-line: align
    this.roleService.GetBreadcrumList(obj).subscribe((data: any) => {
      this.breadcrumList = data.BreadcrumList;
      console.log(data.BreadcrumList);
    }, (error) => {
      this.toaster.error('Error', error.ErrorMessage);
    });
  }

  openEditPolicyItemModel(element: any){
    const data = this.policyDataArray.find(x => x.id == element.id);
    this.policyRowId = data.id;
    this.policyForm.get('minimumLength')?.setValue(data.minimumLength);
    this.policyForm.get('isAlphanumeric')?.setValue(data.isAlphanumeric);
    this.policyForm.get('isSymbol')?.setValue(data.isSymbols);
    this.policyForm.get('expiryPeriod')?.setValue(data.expiryPeriodDayWise);
    this.policyForm.get('logOffTimeOut')?.setValue(data.logOffTimeOutHourly);
    this.policyForm.get('failedAttempt')?.setValue(data.failedAttempt);
    if(data.isCheckPreviousPassword){
      this.isCheckPrevious = true;
      this.policyForm.get("noOfPreviousPass").setValidators([Validators.required,Validators.min(1)]);
      this.policyForm.get("noOfPreviousPass").updateValueAndValidity();
      this.policyForm.get('isCheckPreviousPass')?.setValue(data.isCheckPreviousPassword);
      this.policyForm.get('noOfPreviousPass')?.setValue(data.noOfPreviousPassword);
    }
    this.formMode = false;
    this.displayUserModal = true;
  }
  deletePolicy(element: any){
    const data = {
      id: element.id
    };
    this.policyService.deletePolicy(data).subscribe(res => {
      if(res){
        this.toaster.success(res.message);
        this.getpolicy();
      }
    },
    (error) => {
      this.toaster.error(error);
    });
  }
}
